import React from 'react';

const ChartEmptyIcon: React.FC<{ isNotBg?: boolean }> = ({ isNotBg }) =>
  isNotBg ? (
    <svg width="73" height="73" viewBox="0 0 73 73" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="27.1664"
        y="1.66641"
        width="51"
        height="51"
        rx="13.5"
        transform="rotate(30 27.1664 1.66641)"
        fill="white"
      />
      <rect
        x="27.1664"
        y="1.66641"
        width="51"
        height="51"
        rx="13.5"
        transform="rotate(30 27.1664 1.66641)"
        stroke="#D2D6DB"
      />
      <g filter="url(#filter0_i_34826_93097)">
        <rect x="1.9834" y="14.9277" width="52" height="52" rx="14" fill="white" />
        <rect x="2.4834" y="15.4277" width="51" height="51" rx="13.5" stroke="#D2D6DB" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.9811 27.695C31.6274 27.2843 30.3979 28.2445 30.1772 29.476L28.7502 37.4369C28.4634 39.0365 29.8589 40.432 31.4586 40.1453L39.4194 38.7183C40.6509 38.4975 41.6111 37.268 41.2005 35.9143C40.0086 31.9847 36.9107 28.8869 32.9811 27.695Z"
          fill="#00A389"
        />
        <g opacity="0.4">
          <path
            d="M28.0185 30.1872C28.0458 30.0351 27.9384 29.8914 27.7843 29.8784C27.4371 29.849 27.0857 29.834 26.7308 29.834C19.9193 29.834 14.3975 35.3558 14.3975 42.1673C14.3975 48.9788 19.9193 54.5007 26.7308 54.5007C33.5423 54.5007 39.0641 48.9788 39.0641 42.1673C39.0641 41.8114 39.049 41.4589 39.0195 41.1106C39.0064 40.9566 38.8628 40.8492 38.7106 40.8765L31.8124 42.113C28.8416 42.6455 26.2499 40.0539 26.7824 37.0831L28.0185 30.1872Z"
            fill="#00A389"
          />
          <path
            d="M30.0336 30.2812C34.1891 31.4334 37.4629 34.7064 38.6161 38.8615L31.4595 40.1444C29.8598 40.4311 28.4643 39.0356 28.7511 37.4359L30.0336 30.2812Z"
            fill="#00A389"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_i_34826_93097"
          x="1.9834"
          y="12.0277"
          width="52"
          height="54.9"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-4" />
          <feGaussianBlur stdDeviation="1.45" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_34826_93097" />
        </filter>
      </defs>
    </svg>
  ) : (
    <svg width="203" height="173" viewBox="0 0 203 173" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_34826_92594)">
        <line x1="10.5" y1="-4" x2="10.5" y2="178" stroke="#E5E7EB" />
        <line x1="28.5" y1="-4" x2="28.5" y2="178" stroke="#E5E7EB" />
        <line x1="46.5" y1="-4" x2="46.5" y2="178" stroke="#E5E7EB" />
        <line x1="64.5" y1="-4" x2="64.5" y2="178" stroke="#E5E7EB" />
        <line x1="82.5" y1="-4" x2="82.5" y2="178" stroke="#E5E7EB" />
        <line x1="100.5" y1="-4" x2="100.5" y2="178" stroke="#E5E7EB" />
        <line x1="118.5" y1="-4" x2="118.5" y2="178" stroke="#E5E7EB" />
        <line x1="136.5" y1="-4" x2="136.5" y2="178" stroke="#E5E7EB" />
        <line x1="154.5" y1="-4" x2="154.5" y2="178" stroke="#E5E7EB" />
        <line x1="172.5" y1="-4" x2="172.5" y2="178" stroke="#E5E7EB" />
        <line x1="190.5" y1="-4" x2="190.5" y2="178" stroke="#E5E7EB" />
        <line x1="242.688" y1="16.5908" x2="-42.8176" y2="14.5003" stroke="#E5E7EB" />
        <line x1="242.556" y1="34.5898" x2="-42.9494" y2="32.4994" stroke="#E5E7EB" />
        <line x1="242.424" y1="52.5898" x2="-43.081" y2="50.4994" stroke="#E5E7EB" />
        <line x1="242.292" y1="70.5889" x2="-43.2129" y2="68.4984" stroke="#E5E7EB" />
        <line x1="242.16" y1="88.5889" x2="-43.3447" y2="86.4984" stroke="#E5E7EB" />
        <line x1="242.029" y1="106.588" x2="-43.4765" y2="104.497" stroke="#E5E7EB" />
        <line x1="241.897" y1="124.588" x2="-43.6084" y2="122.497" stroke="#E5E7EB" />
        <line x1="241.765" y1="142.587" x2="-43.7402" y2="140.496" stroke="#E5E7EB" />
        <line x1="241.633" y1="160.587" x2="-43.8718" y2="158.496" stroke="#E5E7EB" />
        <rect
          x="104.683"
          y="56.683"
          width="51"
          height="51"
          rx="13.5"
          transform="rotate(30 104.683 56.683)"
          fill="white"
        />
        <rect
          x="104.683"
          y="56.683"
          width="51"
          height="51"
          rx="13.5"
          transform="rotate(30 104.683 56.683)"
          stroke="#D2D6DB"
        />
        <g filter="url(#filter0_i_34826_92594)">
          <rect x="79.5" y="69.9443" width="52" height="52" rx="14" fill="white" />
          <rect x="80" y="70.4443" width="51" height="51" rx="13.5" stroke="#D2D6DB" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M110.498 82.7116C109.144 82.3009 107.915 83.2611 107.694 84.4926L106.267 92.4535C105.98 94.0531 107.376 95.4486 108.975 95.1619L116.936 93.7349C118.168 93.5141 119.128 92.2846 118.717 90.9309C117.525 87.0013 114.427 83.9035 110.498 82.7116Z"
            fill="#00A389"
          />
          <g opacity="0.4">
            <path
              d="M105.535 85.2038C105.562 85.0517 105.455 84.908 105.301 84.895C104.954 84.8656 104.602 84.8506 104.247 84.8506C97.4359 84.8506 91.9141 90.3724 91.9141 97.1839C91.9141 103.995 97.4359 109.517 104.247 109.517C111.059 109.517 116.581 103.995 116.581 97.1839C116.581 96.828 116.566 96.4755 116.536 96.1272C116.523 95.9732 116.379 95.8658 116.227 95.8931L109.329 97.1296C106.358 97.6621 103.767 95.0705 104.299 92.0997L105.535 85.2038Z"
              fill="#00A389"
            />
            <path
              d="M107.55 85.2978C111.706 86.45 114.979 89.723 116.133 93.8781L108.976 95.161C107.376 95.4477 105.981 94.0522 106.268 92.4525L107.55 85.2978Z"
              fill="#00A389"
            />
          </g>
        </g>
        <circle cx="96.5" cy="89.5" r="145.5" fill="url(#paint0_radial_34826_92594)" />
      </g>
      <defs>
        <filter
          id="filter0_i_34826_92594"
          x="79.5"
          y="67.0443"
          width="52"
          height="54.9"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-4" />
          <feGaussianBlur stdDeviation="1.45" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_34826_92594" />
        </filter>
        <radialGradient
          id="paint0_radial_34826_92594"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(96.5 89.5) rotate(90) scale(145.5)"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="0.73" stopColor="white" />
        </radialGradient>
        <clipPath id="clip0_34826_92594">
          <rect width="203" height="173" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );

export default ChartEmptyIcon;
